function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'barely-blue': 'rgb(216, 233, 237)','sky-blue': 'rgb(193, 204, 219)','dusty-pink': 'rgb(194, 121, 125)','cappucino': 'rgb(196, 175, 137)','stone-blue': 'rgb(134, 159, 168)','powder': 'rgb(230, 238, 255)','cool-mint': 'rgb(201, 255, 242)','military-green': 'rgb(91, 103, 79)','warm-grey': 'rgb(184, 178, 182)','charcoal': 'rgb(54, 54, 54)','sky': 'rgb(183, 219, 255)','slate': 'rgb(98, 120, 155)','heather-plum': 'rgb(154, 115, 134)','teal': 'rgb(145, 228, 228)','frost-blue': 'rgb(107, 128, 143)','cloud': 'rgb(213, 213, 213)','jade': 'rgb(152, 191, 175)','sandy': 'rgb(205, 203, 196)','cypress': 'rgb(136, 177, 172)','peach': 'rgb(247, 195, 155)','sage': 'rgb(156, 181, 174)','sand': 'rgb(217, 215, 202)','midnight': 'rgb(31, 39, 48)','heather-grey': 'rgb(175, 172, 177)','heather-navy': 'rgb(55, 63, 92)','burgundy': 'rgb(113, 24, 42)','emerald': 'rgb(60, 107, 96)','eden': 'rgb(67, 82, 47)','mauve': 'rgb(190, 102, 100)','grey-sky': 'rgb(227, 231, 237)','banana': 'rgb(230, 232, 176)','cream': 'rgb(235, 229, 224)','cool-grey': 'rgb(218, 225, 230)','forest-green': 'rgb(3, 89, 32)','pigment-blue': 'rgb(145, 174, 223)','dark-aqua': 'rgb(36, 136, 158)','blue-ice': 'rgb(129, 188, 230)','white-sand': 'rgb(237, 236, 232)','white-jasmine': 'rgb(238, 236, 231)','dusty-brown': 'rgb(169, 140, 134)','heather-teal': 'rgb(75, 122, 132)','cardinal': 'rgb(153, 37, 46)','asphalt': 'rgb(54, 54, 54)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
